import { render } from "./AttributeModalView.vue?vue&type=template&id=fa0db844&scoped=true"
import script from "./AttributeModalView.vue?vue&type=script&lang=js"
export * from "./AttributeModalView.vue?vue&type=script&lang=js"

import "./AttributeModalView.vue?vue&type=style&index=0&id=fa0db844&scoped=true&lang=css"

import exportComponent from "/Users/kokleng/Documents/old_macbook/document/Dollar/core_system/from_gitlab/pos-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa0db844"]])

export default __exports__